import { Grid, Paper, TextInput } from "@dehub/theme";
import type { UseFormReturnType } from "@dehub/theme";
import { useTranslation } from "react-i18next";
import GoogleMapPin from "@/components/google-map";
import type { LatLng } from "@/components/google-map";
import type { IFormData } from "./warehouse-form";

const DEFAULT_LAT = 47.9192;
const DEFAULT_LNG = 106.9172;
const MAP_ZOOM = 16;

type Props = {
  form: UseFormReturnType<IFormData>;
  isDetail?: boolean;
};

function parseCoord(value: string | undefined, fallback: number): number {
  const parsed = parseFloat(value ?? "");
  if (!Number.isFinite(parsed) || parsed === 0 || parsed === 1) return fallback;
  return parsed;
}

export function WarehouseLocationMap({ form, isDetail }: Props) {
  const { t } = useTranslation("warehouse");

  const center: LatLng = {
    lat: parseCoord(form.values.locationLat, DEFAULT_LAT),
    lng: parseCoord(form.values.locationLng, DEFAULT_LNG),
  };

  const setLocation = (position: LatLng) => {
    form.setFieldValue("locationLat", position.lat.toString());
    form.setFieldValue("locationLng", position.lng.toString());
  };

  return (
    <>
      <Grid.Col span={12}>
        <Paper h={400} w="100%" style={{ border: "1px solid var(--mantine-color-gray-2)", borderRadius: 12, overflow: "hidden" }}>
          <GoogleMapPin center={center} zoom={MAP_ZOOM} readOnly={isDetail} onChange={setLocation} />
        </Paper>
      </Grid.Col>
      <Grid.Col span={6}>
        <TextInput label={t("form.lat")} placeholder={t("form.lat")} withAsterisk readOnly={isDetail} {...form.getInputProps("locationLat")} />
      </Grid.Col>
      <Grid.Col span={6}>
        <TextInput label={t("form.lng")} placeholder={t("form.lng")} withAsterisk readOnly={isDetail} {...form.getInputProps("locationLng")} />
      </Grid.Col>
    </>
  );
}
